import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import ForgotPasswordDisplay from './ForgotPasswordDisplay';

// Ported from UserController / WineryUsers.ascx to provide immediate client-side feedback.
const EMAIL_REGEX = /^[a-zA-Z0-9]([a-zA-Z0-9._+-]*[a-zA-Z0-9])?@[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?(\.[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?)*\.[a-zA-Z]{2,}$/;

class ForgotPasswordContainer extends React.Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    forgotPassword: PropTypes.func.isRequired,
    forgotPasswordLoading: PropTypes.bool.isRequired,
    forgotPasswordSuccess: PropTypes.bool.isRequired
  };

  state = {
    email: '',
    error: undefined
  }

  onKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      e.stopPropagation();
      this.onSubmit();
    }
  }

  onChange = (newValue) => {
    this.setState({ email: newValue });
  }

  onSubmit = () => {
    const { email } = this.state;
    if (email === '') {
      this.setState({ error: 'Please enter your email address' });
      return;
    }
    if (!EMAIL_REGEX.test(email)) {
      this.setState({ error: 'Please enter a valid email address' });
      return;
    }
    this.setState({ error: undefined });
    const { forgotPassword } = this.props;
    forgotPassword(email);
  }

  backToLogin = () => {
    this.props.history.push('/login');
  }

  render() {
    return (
      <ForgotPasswordDisplay
        email={ this.state.email }
        error={ this.state.error }
        onChange={ this.onChange }
        onKeyDown={ this.onKeyDown }
        onSubmit={ this.onSubmit }
        backToLogin={ this.backToLogin }
        loading={ this.props.forgotPasswordLoading }
        success={ this.props.forgotPasswordSuccess }
      />
    );
  }
}

export default withRouter(ForgotPasswordContainer);
